import { Injectable } from '@angular/core';
import { SuperHttpClientProvider } from '@app/core/http';
import { Observable, of } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';

export interface MoistureZonesResponse {
  zoneAxis?: string;
  zones?: Array<{ value?: number; color?: string }>;
  profileName?: string | null;
  seasonName?: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class SensorMoistureZonesService {
  private cache = new Map<string, Observable<MoistureZonesResponse | null>>();

  constructor(private $shttp: SuperHttpClientProvider) {}

  getZones(sensorId: number, at: string): Observable<MoistureZonesResponse | null> {
    const key = `${sensorId}|${at}`;
    const cached = this.cache.get(key);
    if (cached) {
      return cached;
    }

    const request$ = this.$shttp.default
      .get(`/admin/sensor/${sensorId}/moisture-zones?at=${encodeURIComponent(at)}`)
      .pipe(
        catchError(() => of(null)),
        shareReplay(1)
      );

    this.cache.set(key, request$);
    return request$;
  }
}
